let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gBVkE")).then(() => parcelRequire('4x9d9'));